import { useTheme } from '@emotion/react';
import {
  Button,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { UPDATE_TIMER } from 'constant/app.config';
import { useContext, useState } from 'react';
import Swal from 'sweetalert2';
import { poppins400, poppins500 } from 'theme/common.style';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Loading from 'assets/images/loading.png';
import { useEffect } from 'react';
import { datacontext } from 'modules/AppLayout/AppLayout';

dayjs.extend(utc);
dayjs.extend(timezone);

function Timerstatus({
  openBox,
  setOpenBox,
  profileDetails,
  actionValue,
  getListInfo,
  dashboard,
  activityfun,
  publishcard,
  unpublishcard,
  offerdata,
}) {
  const endedAt = profileDetails?.endedAt;
  const endedAtTime = endedAt ? dayjs.tz(endedAt, 'Australia/Sydney') : null;
  const currentSydneyTime = dayjs().tz('Australia/Sydney');

  const isDisabled = (minutesToAdd) => {
    if (!endedAtTime) return false;
    return endedAtTime.isBefore(currentSydneyTime.add(minutesToAdd, 'minute'));
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [pausetime, setPausetime] = useState(0);
  const [pausetimeerror, setPausetimeerror] = useState({
    helperText: '',
    error: false,
  });
  const [pausereason, setPausereason] = useState('');
  const [pausereasonerror, setPausereasonerror] = useState(false);
  const [pausetimeinmin, setPausetimeinmin] = useState(0);
  const [timerLoading, setTimerLoading] = useState(false);
  const context = useContext(datacontext);
  const bannerApiTrigger = context?.bannerApiTrigger;

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForAgentAck))
      Moxoseparationinlisting('dataForAgentAck', res?.data?.dataForAgentAck); //1
    if (isNotEmptyArray(res?.data?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAck', res?.data?.dataForBuyerAck); //2
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //3
  };

  const updateCampign = (status) => {
    const dataParams = {
      propertyId: profileDetails?.property?.propertyId,
      timerId: profileDetails?.timerId,
      // updatedById: profileDetails?.property?.createdById,
      timerStatus: status,
    };

    if (status == 'Pause') {
      dataParams.pausedTime = pausetimeinmin;
      dataParams.pausedReason = pausereason;
    }
    dataParams.isManual = 1;

    setTimerLoading(true);

    postApiCall(UPDATE_TIMER, dataParams)
      .then(async (res) => {
        if (res?.data?.status == 1) {
          if (!dashboard) {
            await getListInfo();
            await offerdata();
          } else {
            // await publishcard();
            // await unpublishcard();
            // await activityfun();
          }
          bannerApiTrigger();
          moxoapis(res);

          setTimerLoading(false);
          if (status == 'Pause') {
            setPausetime(0);
            setPausereason('');
          }
          setOpenBox(false);
          // ✅ Popup closes only after Swal confirmation
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            html:
              status == 'Pause'
                ? `The Campaign has been Paused successfully and will automatically resume at 
          <span><b style={{ fontFamily: "Poppins", fontWeight: 550, color:"#666666"}}>
          ${res?.data?.returnTime}
          </b></span>`
                : res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            }
          });
        }

        if (res?.data?.status == '-1') {
          setTimerLoading(false);
          if (status == 'Pause') {
            setPausetime(0);
            setPausereason('');
          }

          Swal.fire({
            title: 'Error',
            text:
              res?.data?.message || 'Something went wrong. Please try again.',
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              setOpenBox(false);
            }
          });
        } else {
          setTimerLoading(false);
          if (status == 'Pause') {
            setPausetime(0);
            setPausereason('');
          }
        }
      })
      .catch(() => {
        setTimerLoading(false);
        if (status == 'Pause') {
          setPausetime(0);
          setPausereason('');
        }

        Swal.fire({
          title: 'Error',
          text: 'Network error occurred. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
            setOpenBox(false);
          }
        });
      });
  };

  const handleChange = (e) => {
    let time;
    const value = e.target.value;

    // Check if the value contains "Days"
    if (value?.includes('Days')) {
      const days = parseInt(value);
      time = days * 24 * 60;
    }
    // Check if the value contains "Day"
    else if (value?.includes('Day')) {
      time = 1 * 24 * 60;
    }
    // Check if the value contains "Hours"
    else if (value?.includes('hours') || value?.includes('hour')) {
      const hours = parseInt(value);
      time = hours * 60;
    }
    // If none of the above, default to 0
    else {
      time = 0;
    }
    setPausetimeinmin(time);
    setPausetime(e.target.value);
    setPausetimeerror({
      helperText: '',
      error: false,
    });
  };

  const valueFunc = () => {
    if (actionValue == 'Start') {
      updateCampign('Start');
    } else if (actionValue == 'Pause') {
      if (pausetime == 0) {
        setPausetimeerror({
          helperText: 'Choose an option',
          error: true,
        });
        return;
      } else {
        setPausetimeerror({
          helperText: '',
          error: false,
        });
      }
      if (pausereason.trim().split(/\s+/).length < 10) {
        setPausereasonerror(true);
        return;
      } else {
        setPausereasonerror(false);
      }
      updateCampign('Pause');
    } else if (actionValue == 'End') {
      updateCampign('End');
    }
  };

  useEffect(() => {
    if (timerLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [timerLoading]);

  return (
    <Dialog
      open={openBox}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          // height: matchessm ? "350px" : "300px",/
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {'   '}
            {profileDetails?.propertyAddress?.streetName}
            &nbsp;
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'12px 0px 15px 0'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            {actionValue == 'Start'
              ? 'Resume Campaign'
              : actionValue == 'Pause'
              ? 'Pause Campaign'
              : actionValue == 'End' && 'End Campaign'}
          </Typography>
        </Grid>

        <Grid
          item
          xs={matchessm ? 12 : 12}
          textAlign={'left'}
          marginBottom={'10px'}
        >
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              display: 'flex',
              alignItems: 'center',
            }}
            // whiteSpace={"nowrap"}
          >
            {actionValue == 'Start' ? (
              <>
                Once the Campaign is Resumed, buyers will be able to submit new
                offers.
                <br />
                <br />
                Would you like to Resume the Campaign now?{' '}
              </>
            ) : actionValue == 'Pause' ? (
              <>
                Buyers will be unable to submit new offers whilst the campaign
                is Paused.
                <br />
                Would you like to Pause the Campaign now?{' '}
              </>
            ) : (
              actionValue == 'End' && (
                <>
                  By Ending the Campaign no further offers will be accepted.
                  <br />
                  This campaign will be permanently closed. <br />
                  Are you sure you would like to End the Campaign now?
                </>
              )
            )}
          </Typography>
        </Grid>

        {actionValue == 'Pause' && (
          <>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} sm={5}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Resume Campaign in
                </Typography>
              </Grid>

              <Grid item xs={12} sm={7}>
                <FormControl fullWidth error={pausetimeerror.error}>
                  <Select
                    value={pausetime}
                    onChange={handleChange}
                    displayEmpty
                    disableUnderline
                    IconComponent={GridExpandMoreIcon}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: '#999' }}>Select duration</span>
                        );
                      }
                      return selected;
                    }}
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: matchessm ? '12px' : '14px',
                      height: matchessm ? '32px' : '38px',
                      color: '#666666',
                    }}
                  >
                    {/* <MenuItem value="" disabled>
                      Choose here...
                    </MenuItem> */}
                    {[
                      { label: '3 Days', minutes: 3 * 24 * 60 },
                      { label: '1 Day', minutes: 1 * 24 * 60 },
                      { label: '18 hours', minutes: 18 * 60 },
                      { label: '12 hours', minutes: 12 * 60 },
                      { label: '6 hours', minutes: 6 * 60 },
                      { label: '3 hours', minutes: 3 * 60 },
                      { label: '1 hour', minutes: 1 * 60 },
                    ].map((item) => (
                      <MenuItem
                        key={item.label}
                        value={item.label}
                        disabled={isDisabled(item.minutes)}
                        sx={{
                          fontFamily: 'Poppins',
                          fontWeight: 300,
                          fontSize: matchessm ? '12px' : '14px',
                        }}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {pausetimeerror.error && (
                    <FormHelperText sx={{ fontFamily: 'Poppins' }}>
                      {pausetimeerror.helperText}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={0} sm={1.5}></Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              marginTop={'10px'}
            >
              <TextField
                // sx={[textboxmargin_description, { marginTop: "10px" }]}
                multiline={true}
                fullWidth
                rows={4}
                // helperText={errorMessageDescription.helperText}
                error={pausereasonerror}
                placeholder="Reason for pausing campaign"
                id="heading"
                type="input"
                name="heading"
                value={pausereason}
                onChange={(event) => {
                  let value = event.target.value;
                  // Split into sentences
                  let sentences = value.split('. ');

                  // Capitalize the first letter of the first sentence and lowercase the rest
                  if (sentences.length > 0) {
                    sentences = sentences.map((sentence, index) => {
                      if (index === 0) {
                        return (
                          sentence.charAt(0).toUpperCase() +
                          sentence.slice(1).toLowerCase()
                        );
                      } else {
                        return sentence.toLowerCase();
                      }
                    });
                  }

                  // Join the sentences back together
                  value = sentences.join('. ');

                  setPausereason(value);
                  if (event.target.value.trim().split(/\s+/).length > 10) {
                    setPausereasonerror(false);
                  }
                }}
                inputProps={{
                  style: {
                    fontFamily: 'poppins',
                    textTransform: 'none',
                    fontSize: matchessm ? '12px' : '14px',
                    fontWeight: '300',
                  },
                }}
              />
            </Grid>
            <FormHelperText
              style={{
                color: pausereasonerror ? '#d32f2f' : '#666666',
                fontFamily: 'poppins',
              }}
            >
              (Minimum 10 words required)
            </FormHelperText>
          </>
        )}
        <Grid
          item
          container
          direction="row"
          sx={{ display: 'flex', alignItems: 'center' }}
          justifyContent={'flex-end'}
          gap={2}
          marginTop={matchessm ? '15px' : 5}
        >
          <Grid item>
            <Button
              disabled={timerLoading}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={() => setOpenBox(!openBox)}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              disabled={timerLoading}
              onClick={() => {
                // setConfirmBtn(confirmBtn);
                // ActionTimer(confirmBtn);
                // setOpenBox(!openBox);
                valueFunc();
              }}
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              // disabled={loading}
            >
              {/* {confirmBtn} */}
              {actionValue == 'Start' ? 'Resume' : actionValue}
            </Button>
            {timerLoading && (
              <img
                alt="Loader"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }} // 🔹 smaller & aligned
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default Timerstatus;
